import { useMemo, useState } from "react";
import { Button, Space, Tooltip, Input } from "antd";
import { PlusOutlined, FilterOutlined, DownloadOutlined, SearchOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { useDebounce } from "../../../shared/components/ui/hooks";
import { WrapperCard } from "./styled";
import { useCounterProductsTable, useProducts } from "../hooks";
import { TableProducts } from "./TableProducts";

export const Products = () => {
  const { querySelectorTransform, navigateProductsCreate, handleQueryTransform } = useProducts();
  const { setQuerySelector, getDownloadProductsWithFilters } = useCounterProductsTable({ handleQueryTransform });
  const [searchText, setSearchText] = useState("");
  const { value: debouncedSearch } = useDebounce(searchText, 400);

  const fetchQuery = useMemo(() => {
    const term = debouncedSearch?.trim();
    return {
      ...querySelectorTransform,
      ...(term ? { data_value: term } : {}),
    };
  }, [querySelectorTransform, debouncedSearch]);

  return (
    <AdminMenuLayout pageDescription="Gestión de productos" title="Productos">
      <WrapperCard bodyStyle={{ padding: "24px", display: "block" }}>
        <div style={{ 
          marginBottom: 24, 
          display: "flex", 
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #f0f0f0",
          paddingBottom: 16
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, margin: 0, flexShrink: 0 }}>Listado de Productos</h2>

          <Input
            allowClear
            placeholder="Buscar por nombre, código, ID, categoría o marca..."
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{
              flex: 1,
              maxWidth: 420,
              margin: "0 16px",
              borderRadius: 10,
              height: 44,
            }}
          />

          <Space size={12} style={{ flexShrink: 0 }}>
            <Tooltip title="Descargar lista">
              <Button
                icon={<DownloadOutlined style={{ fontSize: 18, color: "#595959" }} />}
                size="large"
                onClick={getDownloadProductsWithFilters}
                style={{ 
                  border: "none",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "12px",
                  width: 44,
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.02)"
                }}
              />
            </Tooltip>
            <Tooltip title="Limpiar filtros">
              <Button
                icon={<FilterOutlined style={{ fontSize: 18, color: "#595959" }} />}
                size="large"
                onClick={() => {
                  setQuerySelector([]);
                  handleQueryTransform([]);
                  setSearchText("");
                }}
                style={{ 
                  border: "none",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "12px",
                  width: 44,
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.02)"
                }}
              />
            </Tooltip>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={navigateProductsCreate}
              style={{ 
                borderRadius: "30px", 
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: "0 4px 10px rgba(233, 87, 53, 0.3)", // Sombra sutil con el color primario
                display: "flex",
                alignItems: "center",
                gap: 8
              }}
            >
              Nuevo Producto
            </Button>
          </Space>
        </div>
        
        <TableProducts fetchQuery={fetchQuery} />
      </WrapperCard>
    </AdminMenuLayout>
  );
};
